import React, { useState } from 'react';
import Cookies from 'js-cookie';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import Topbar from '../layouts/Topbar';
import Sidebar from '../layouts/Sidebar';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaEye, FaEyeSlash, FaLock, FaKey } from 'react-icons/fa';
import API_BASE_URL from '../../../config/api';


const HODChangePassword = () => {
    const baseUrl = API_BASE_URL;
    const [form, setForm] = useState({
        old_password: '',
        new_password: '',
        confirm_password: ''
    });
    const [loading, setLoading] = useState(false);
    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.old_password || !form.new_password || !form.confirm_password) {
            toast.error('All fields are required.');
            return;
        }
        if (form.new_password !== form.confirm_password) {
            toast.error('New password and confirm password do not match.');
            return;
        }
        setLoading(true);
        try {
            const token = Cookies.get('token');
            await axios.post(
                `${baseUrl}/api/change-password/`,
                {
                    old_password: form.old_password,
                    new_password: form.new_password,
                    confirm_password: form.confirm_password
                },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            toast.success('Password changed successfully.');
            setForm({ old_password: '', new_password: '', confirm_password: '' });
        } catch (err) {
            toast.error(
                err.response?.data?.detail ||
                err.response?.data?.message ||
                'Failed to change password.'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Topbar />
            <Sidebar />
            <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} newestOnTop closeOnClick pauseOnFocusLoss draggable pauseOnHover />
            <div className="dashboard-container">
                
                <div style={{marginTop: '20px'}} className="content-wrapper">
                    <div className="form-card" style={{ maxWidth: 620, margin: '0 auto', background: '#fffb', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.04)', padding: 32 }}>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group" style={{ marginBottom: 40, position: 'relative' }}>
                                <label htmlFor="old_password" style={{ fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block' }}>Old Password</label>
                                <div style={{ position: 'relative' }}>
                                    <span style={{ position: 'absolute', left: 12, top: 12, color: '#818CF8', fontSize: 18 }}><FaKey /></span>
                                    <input
                                        type={showOld ? 'text' : 'password'}
                                        id="old_password"
                                        name="old_password"
                                        value={form.old_password}
                                        onChange={handleChange}
                                        className="form-control"
                                        style={{ width: '80%', padding: '10px 38px 10px 38px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 16 }}
                                        autoComplete="current-password"
                                        disabled={loading}
                                        required
                                    />
                                    <span
                                        onClick={() => setShowOld((v) => !v)}
                                        style={{ position: 'absolute', right: 12, top: 12, color: '#818CF8', fontSize: 18, cursor: 'pointer' }}
                                    >
                                        {showOld ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: 40, position: 'relative' }}>
                                <label htmlFor="new_password" style={{ fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block' }}>New Password</label>
                                <div style={{ position: 'relative' }}>
                                    <span style={{ position: 'absolute', left: 12, top: 12, color: '#818CF8', fontSize: 18 }}><FaLock /></span>
                                    <input
                                        type={showNew ? 'text' : 'password'}
                                        id="new_password"
                                        name="new_password"
                                        value={form.new_password}
                                        onChange={handleChange}
                                        className="form-control"
                                        style={{ width: '80%', padding: '10px 38px 10px 38px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 16 }}
                                        autoComplete="new-password"
                                        disabled={loading}
                                        required
                                    />
                                    <span
                                        onClick={() => setShowNew((v) => !v)}
                                        style={{ position: 'absolute', right: 12, top: 12, color: '#818CF8', fontSize: 18, cursor: 'pointer' }}
                                    >
                                        {showNew ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                            </div>
                            <div className="form-group" style={{ marginBottom: 40, position: 'relative' }}>
                                <label htmlFor="confirm_password" style={{ fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block' }}>Confirm New Password</label>
                                <div style={{ position: 'relative' }}>
                                    <span style={{ position: 'absolute', left: 12, top: 12, color: '#818CF8', fontSize: 18 }}><FaLock /></span>
                                    <input
                                        type={showConfirm ? 'text' : 'password'}
                                        id="confirm_password"
                                        name="confirm_password"
                                        value={form.confirm_password}
                                        onChange={handleChange}
                                        className="form-control"
                                        style={{ width: '80%', padding: '10px 38px 10px 38px', borderRadius: 8, border: '1px solid #e5e7eb', fontSize: 16 }}
                                        autoComplete="new-password"
                                        disabled={loading}
                                        required
                                    />
                                    <span
                                        onClick={() => setShowConfirm((v) => !v)}
                                        style={{ position: 'absolute', right: 12, top: 12, color: '#818CF8', fontSize: 18, cursor: 'pointer' }}
                                    >
                                        {showConfirm ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ width: '100%', padding: '12px 0', borderRadius: 8, background: '#4F46E5', color: 'white', fontWeight: 600, fontSize: 16, border: 'none', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1 }}
                                disabled={loading}
                            >
                                {loading ? 'Changing...' : 'Change Password'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default HODChangePassword
